// Polyfill modern JS features, like promises, async functions, etc.
import "core-js/stable";
import "regenerator-runtime/runtime";
import "@rails/actiontext";

require("@rails/activestorage").start();

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true);
// const imagePath = (name) => images(name, true);

import "./stylesheets/application.scss";
import "./mdc";
import "./admin_dashboard/app";
import "./controllers";
import "@hotwired/turbo-rails";
import "./hotwire_fix";
